import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import JobtitleTable from 'components/jobtitle/JobtitleTable';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useEffect, useContext } from 'react';
import JobtitleServices from 'services/JobtitleServices';
import sidebar from 'routes/sidebar';
import JobtitleDrawer from 'components/drawer/JobtitleDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import { SidebarContext } from 'context/SidebarContext';
import { FiPlus } from 'react-icons/fi';
import DataWrapper from './DataWrapper';
import { FiRefreshCcw } from 'react-icons/fi';

const Jobtitle = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { data, loading, error } = useAsync(JobtitleServices.getAllJobtitle);
	//const jobtitle = data?.data || [];
	// const [loading, setLoading] = useState(false);
	const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [itemsPerPage, setItemsPerPage] = useState(10);

	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'job post' && perm.view === 1
		  );

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'job post' && perm.delete === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'job post' && perm.edit === 1
		  );

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'job post' && perm.add === 1
		  );

	const [jobtitleData, setJobtitleData] = useState([]);
	const [status, setStatus] = useState('');
	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);
	const {
		jobtitleRef,
		dataTable,
		serviceData,
		handleSubmitJobtitle,
		currentPage,
	} = useFilter(jobtitleData, itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		if (data) {
			const responseData = data?.data || [];
			if (Array.isArray(responseData)) {
				const updatedData = responseData.map(
					({ id, job_roles, description, skills, salary, ...rest }) => ({
						id,
						job_roles,
						description,
						skills,
						salary,

						...rest,
					})
				);
				setJobtitleData(updatedData);
			} else {
				console.error('Expected an array but got:', responseData);
			}
		} else {
			console.error('Data is null or undefined');
		}
	}, [data]);

	const handleRefresh = () => {
		setIsUpdate(true);
	};
	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />
					<MainDrawer>
						<JobtitleDrawer id={serviceId} />
					</MainDrawer>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div style={{ width: '600px' }}>
									<Input
										ref={jobtitleRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										autoComplete="off"
										name="search"
										placeholder="Quick Search"
										onChange={handleSubmitJobtitle}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add Jobtitle
									</Button>
								)}

								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer
								className="mb-4"
								style={{
									maxHeight: '60vh',
									overflowY: 'scroll',
									scrollbarWidth: 'thin',
								}}
							>
								<Table>
									<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
										<tr>
											<TableCell className="text-center">Sl.No.</TableCell>
											<TableCell className="text-center">Job Role</TableCell>
											<TableCell className="text-center">
												Active/Inactive
											</TableCell>
											<TableCell className="text-center">Actions</TableCell>
										</tr>
									</TableHeader>
									<JobtitleTable
										hideEdit={hideEdit}
										hideDelete={hideDelete}
										jobtitle={dataTable}
										perpage={itemsPerPage}
										currentPage={currentPage}
									/>
								</Table>
								{/* <TableFooter>
            <Pagination
              totalResults={totalResults}
              resultsPerPage={resultsPerPage}
              onChange={handleChangePage}
              label="Table navigation"
            />
          </TableFooter> */}
							</TableContainer>
						) : (
							<NotFound title="There are no JobTitles." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Jobtitle;
